export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";

// UI
export const ADMIN_LOGIN_LOADING = "ADMIN_LOGIN_LOADING";
export const STOP_ADMIN_LOGIN_LOADING = "STOP_ADMIN_LOGIN_LOADING";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";
export const CLEAR_LOGIN_ERROR = "CLEAR_LOGIN_ERROR";
export const LOADING = "LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const ADMIN_LOGIN = "ADMIN_LOGIN";
export const ADMIN_LOGOUT = "ADMIN_LOGOUT";
export const INQUIRY_FORM_OPEN = "INQUIRY_FORM_OPEN";
export const INQUIRY_FORM_CLOSE = "INQUIRY_FORM_CLOSE";
export const CHANGE_THEME = "CHANGE_THEME";
export const SET_THEME = "SET_THEME";
export const SET_COVER = "SET_COVER";
// Admin
export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const SET_COVER_IMAGE = "SET_COVER_IMAGE";

// Menu
export const GET_MENU = "GET_MENU";
export const OPEN_EDIT_MENU_ITEM_DIALOG = "OPEN_EDIT_MENU_ITEM_DIALOG";
export const CLOSE_EDIT_MENU_ITEM_DIALOG = "CLOSE_EDIT_MENU_ITEM_DIALOG";
export const SET_MENU_ID = "SET_MENU_ID";
export const REMOVE_MENU_ID = "REMOVE_MENU_ID";
export const UPDATE_MENU_ITEM = "UPDATE_MENU_ITEM";
export const DELETE_MENU_ITEM = "DELETE_MENU_ITEM";
export const SET_PRESENT_ORDER_NUM = "SET_PRESENT_ORDER_NUM";
export const STORE_FETURED_IMAGE = "STORE_FETURED_IMAGE";
export const SET_IMAGE_LOADING = "SET_IMAGE_LOADING";
export const STOP_IMAGE_LOADING = "STOP_IMAGE_LOADING";
export const SET_IMAGE_SUCCESSFULLY_UPLAODED =
  "SET_IMAGE_SUCCESSFULLY_UPLAODED";
export const UNSET_IMAGE_SUCCESSFULLY_UPLAODED =
  "UNSET_IMAGE_SUCCESSFULLY_UPLAODED";

// Categories
export const GET_CATEGORIES = "GET_CATEGORIES";
